// @flow

import styled from 'styled-components';

const styles = {};

styles.Spinner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  width: 100%;
  height: 100%;
`;

export default styles;
